<template>
	<div class="menu-container"  >
	<img src="../assets/static/images/logo.png" class="logo-kyx" style="margin-right: 15rem;">
		<a-menu mode="horizontal" style="margin-left: -13rem;z-index: 5;" >
		      <a-menu-item key="home"  @mouseover="hideOnTip()">
				  <router-link :to="{path:'/home'}">首页</router-link>
				   </a-menu-item>
			   <a-menu-item  key="hardware" @mouseover="showTip()"   class="hardware" :to="{path:'/home'}"> 
			   <router-link :to="{path:'/hardware'}">智能硬件</router-link>
			   </a-menu-item>
				 <a-sub-menu title="软件产品" @mouseover="hideOnTip()" @click="goToSoftware()">
						 <a-menu-item key="instrument"> 
						 <router-link :to="{path:'/software/instrument'}">仪器管理系统 </router-link>
						 </a-menu-item>
						 <a-menu-item key="safetySystem">
						 <router-link :to="{path:'/software/safetySystem'}">实验室安全系统 </router-link> </a-menu-item>
						 <a-menu-item key="shareSystem">
							 <router-link :to="{path:'/software/shareSystem'}">共享支持系统  </router-link> </a-menu-item>
						 <a-menu-item key="danger">
						<router-link :to="{path:'/software/danger'}">	 危化品管理系统 </router-link> </a-menu-item>
						 <a-menu-item key="animal">
						<router-link :to="{path:'/software/animal'}">	 动物房管理系统 </router-link></a-menu-item>
				</a-sub-menu>
				<!-- <a-sub-menu title="产品售后" @mouseover="hideOnTip()">
					<a-menu-item key="l1g">
					<router-link :to="{path:'/software/instrument'}">安装售后 </router-link>
					</a-menu-item>
					<a-menu-item key="l1gs">
					<router-link :to="{path:'/software/instrument'}">系统常规列表 </router-link>
					</a-menu-item>
					</a-sub-menu> -->
			<a-menu-item key="afterSale" @mouseover="hideOnTip()"> 
			<router-link :to="{path:'/afterSale/afterSale'}">产品售后 </router-link></a-menu-item>
			 <a-menu-item key="union" @mouseover="hideOnTip()"> 
			 <router-link :to="{path:'/union/union'}"> 中科联盟 </router-link>
			 </a-menu-item>
			 <a-menu-item key="aboutUs" @mouseover="hideOnTip()">
				<router-link :to="{path:'/aboutUs/aboutUs'}"> 关于我们 </router-link> </a-menu-item>
		    </a-menu>
			<div class="isolated">
				
			</div>
		<div  :class="hardwareHide==0?'hardware_list animate__animated animate__slideInDown':'hardware_list animate__animated animate__slideOutUp'" @mouseleave="hideTip()" :style="hardwareHide==3?'visibility:hidden':''">
			
			<div class="hardware_box" @click="goToHardwareDetail(i+1)" v-for="(item,i) in hardwareData" :key="i">
				<img class="hardware_box_logo" :src="item.SmallPicture"   />
				<p class="hardware_text" >{{item.model}}</p>
				
				<p class="hardware_text2" >{{item.Name}}</p>
				<div style="width: 0.0625rem;height: 4.875rem;background-color: #EEEFF2;position: absolute;right: -0.0625rem;top: 1rem;">
				</div>
			</div>
			<!-- <div class="hardware_box"  @click="goToHardwareDetail(2)">
				<img class="hardware_box_logo" src="../assets/static/images/A10.png" />
				<p class="hardware_text" >A20</p>
				<p class="hardware_text2" >仪器智能控制器</p>
				<div style="width: 0.0625rem;height: 4.875rem;background-color: #EEEFF2;position: absolute;right: -0.0625rem;top: 1rem;">
				</div>
			</div>
			<div class="hardware_box"  @click="goToHardwareDetail(2)">
				<img class="hardware_box_logo" src="../assets/static/images/A10.png" />
				<p class="hardware_text" >A20</p>
				<p class="hardware_text2" >仪器智能控制器</p>
				<div style="width: 0.0625rem;height: 4.875rem;background-color: #EEEFF2;position: absolute;right: -0.0625rem;top: 1rem;">
				</div>
			</div>
			<div class="hardware_box" @click="goToHardwareDetail(3)">
				<img class="hardware_box_logo" src="../assets/static/images/yiqid.png"  />
				<p class="hardware_text">D10</p>
				<p class="hardware_text2" >仪器智能控制器</p>
				<div style="width: 0.0625rem;height: 4.875rem;background-color: #EEEFF2;position: absolute;right: -0.0625rem;top: 1rem;">
				</div>
			</div>
			<div class="hardware_box"  @click="goToHardwareDetail(4)">
				<img class="hardware_box_logo" src="../assets/static/images/mjzn.png"  />
				<p class="hardware_text" >MJ30</p>
				<p class="hardware_text2" >门禁智能控制器</p>
				<div style="width: 0.0625rem;height: 4.875rem;background-color: #EEEFF2;position: absolute;right: -0.0625rem;top: 1rem;">
				</div>
			</div>
			<div class="hardware_box" @click="goToHardwareDetail(5)">
				<img class="hardware_box_logo" src="../assets/static/images/minjinzhin.png"  />
				<p class="hardware_text" >MJ10</p>
				<p class="hardware_text2" >门禁智能控制器</p>
				<div style="width: 0.0625rem;height: 4.875rem;background-color: #EEEFF2;position: absolute;right: -0.0625rem;top: 1rem;">
				</div>
			</div>
			<div class="hardware_box" @click="goToHardwareDetail(6)">
				<img class="hardware_box_logo" src="../assets/static/images/bingxiang.png"  />
				<p class="hardware_text" >BX10</p>
				<p class="hardware_text2" >冰箱智能控制器</p>
				<div style="width: 0.0625rem;height: 4.875rem;background-color: #EEEFF2;position: absolute;right: -0.0625rem;top: 1rem;">
				</div>
			</div>
			<div class="hardware_box" @click="goToHardwareDetail(7)">
				<img  class="hardware_box_logo" src="../assets/static/images/whp.png"  />
				<p class="hardware_text">WH10</p>
				<p class="hardware_text2">危化品智能管控柜</p>
				<div style="width: 0.0625rem;height: 4.875rem;background-color: #EEEFF2;position: absolute;right: -0.0625rem;top: 1rem;">
				</div>
			</div>
			<div class="hardware_box" @click="goToHardwareDetail(8)">
				<img class="hardware_box_logo"  src="../assets/static/images/cwg.png"  />
				<p class="hardware_text">CW10</p>
				<p class="hardware_text2">智能储物柜</p>
				<div style="width: 0.0625rem;height: 4.875rem;background-color: #EEEFF2;position: absolute;right: -0.0625rem;top: 1rem;">
				</div>
			</div>
			<div class="hardware_box"  @click="goToHardwareDetail(9)">
				<img class="hardware_box_logo" src="../assets/static/images/wenshidu.png" />
				<p class="hardware_text">HJ10</p>
				<p class="hardware_text2" >环境温度湿度监测器</p>
				<div style="width: 0.0625rem;height: 4.875rem;background-color: #EEEFF2;position: absolute;right: -0.0625rem;top: 1rem;">
				</div>
			</div>
			<div class="hardware_box"  @click="goToHardwareDetail(10)">
				<img class="hardware_box_logo" src="../assets/static/images/kongqi.png"  />
				<p class="hardware_text" >HJ20</p>
				<p class="hardware_text2" >气体监测器</p>
				<div style="width: 0.0625rem;height: 4.875rem;background-color: #EEEFF2;position: absolute;right: -0.0625rem;top: 1rem;">
				</div>
			</div> -->
		</div>
	</div>
</template>

<script>
	import { scrollAnimation } from '../utils/js/scrollAnimation.js';
	import { hardware} from '../common/api.js'
	export default {
		data(){
			return{
				hardwareHide:3,
				hardware,
				hardwareData:[]
			}
		},
		created(){
			this.getHardware()
		},
	methods:{
		showTip(){
			this.hardwareHide=0
		}
		,
		hideTip(){
			this.hardwareHide=1
		},
		hideOnTip(){
			if(this.hardwareHide!==3){
				this.hardwareHide=1
			}
			
			
			
		},
		async getHardware(){
			 const res =  await hardware({PageIndex:1,PageSize:10000});
			 this.hardwareData= res.data.Data
			console.log(res)
			console.log("这是")
		},
		goToSoftware(){
			// this.$router.push({path:'/software'})
		},
		goToHardwareDetail(i){
			this.$router.push({path:'/hardware',query: {code:i}})
			this.hardwareHide=1
			const currentY = document.documentElement.scrollTop || document.body.scrollTop
			if(i==1){
				scrollAnimation(currentY, 540)
			}
			if(i==2){
				scrollAnimation(currentY, 990)
			}
			if(i==3){
				scrollAnimation(currentY, 1490)
			}
			if(i==4){
				scrollAnimation(currentY, 1890)
			}
			if(i==5){
				scrollAnimation(currentY, 2390)
			}
			if(i==6){
				scrollAnimation(currentY, 2950)
			}
			if(i==7){
				scrollAnimation(currentY, 3290)
			}
			if(i==8){
				scrollAnimation(currentY, 3790)
			}
			if(i==9){
				scrollAnimation(currentY, 4290)
			}
			if(i==10){
				scrollAnimation(currentY, 4690)
				
			}
		},
	
	},
	}
</script>
<style>
	.ant-menu-light{
		border-bottom: none !important;
	}
	.ant-menu-item-active{
		border-bottom: 0.125rem transparent !important;
	}
	.ant-menu-item{
		font-size: 1rem;
		top: 0 !important;
	}
	.ant-menu-submenu-active{
		border-bottom: 0.125rem transparent !important;
	}
	.ant-menu-submenu-title{
		font-size: 1rem;
		margin: 0 1.5rem !important;
		font-family: PingFangSC-Regular, PingFang SC;
		font-weight: 400;
		color: rgba(0, 0, 0, 0.65);
	}
	.ant-menu-item{
		margin: 0 1.5rem !important;
		font-family: PingFangSC-Regular, PingFang SC;
		font-weight: 400;
		color: #333333;
	}
	.ant-menu-item-selected{
		border-bottom: 0.125rem transparent !important;
	}
	.ant-menu-submenu-selected{
		border-bottom: none !important;
	}
	
</style>
<style lang="less" scoped>
	.menu-container{
		display: flex;
		justify-content: center;
		padding-top: 1rem;
	}
	
	.logo-kyx{
		width: 10.25rem;
		height: 3.375rem;
		margin-right: -2rem;
		z-index: 10;
	}
	.hardware_list{
		cursor:pointer;
		width: 75rem;
		align-items: center;
		margin: 0 auto;
		padding-top: 0.5rem;
		position: absolute;
		height: 23rem;
		background-color: red;
		z-index: 3;
		top: 4.2rem;
		display: flex;flex-wrap: wrap;
		box-shadow: 0 0.375rem 0.625rem 0.3125rem rgba(243,243,243,1);
		justify-content: space-between;
		background: #FFFFFF;
		animation-duration: 0.5s;
		
		}
		.isolated{
			width: 79rem;
			height: 5rem;
			margin: 0 auto;
			position: absolute;
			top: 0;
			z-index: 4;
			background-color:white ;
		}
		.hardware_box{
			position: relative;
			display: flex;
			flex-direction: column;
			align-items: center;
			width: 19%;
		}
		.hardware_box:hover .hardware_text {
			color: #4250c3;
			}
			.hardware_box:hover .hardware_text2{
				color: #4250c3;
				
			}
			.hardware_box:hover{
				background-color: rgba(120, 160, 255,0.2);
			
			}
			
		.hardware_box img{
			height: 6.375rem;
			transition: all 0.6s;
			transform: scale(0.8);
			}
			@keyframes logo_scale{
				50%{
					transform: scale(1);
				}
				100%{
					transform: scale(0.9);
				}
			}
			.hardware_box:hover .hardware_box_logo{
				animation: logo_scale 1s;
				 animation-fill-mode:forwards;
			}
			
		.hardware_text{
			font-size: 0.75rem;
			font-family: PingFangSC-Regular, PingFang SC;
			font-weight: 400;
			color: #333333;
		}
		.hardware_text2{
			font-size: 0.75rem;
			font-family: PingFangSC-Regular, PingFang SC;
			font-weight: 400;
			color: #333333;
		}
		.hardware_list_hide{
			display: none;
		}
		.hardware_text{
			margin: 0;
			margin-top: 1rem;
		}
</style>
